import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const SmsPromptSettingsModalSchema = yup.object({
  cellPhone: yup.string().required(REQUIRED_MESSAGE),
  enableUpdates: yup.boolean().required(REQUIRED_MESSAGE),
  enableUpdatesForAllLoads: yup.boolean().when('enableUpdates', {
    is: true,
    then: yup.boolean().required(REQUIRED_MESSAGE),
  }),
})

export type TSmsPromptSettingsModalSchema = yup.InferType<typeof SmsPromptSettingsModalSchema>
